export default function getResource(label, vars = []) {
    const resources = {
        basket: 'basket',
        checkout: 'Checkout',
        item: 'item',
        total: `You have ${vars[0]} in your ${vars[1]}.`,
        applyPoints: 'Apply *500 points* for *$10 off* at Checkout',
        freeShipping: 'FREE Standard Shipping',
        offerDetailsTitle: 'Offer Details',
        readMore: 'Read more',
        readLess: 'Read less',
        apply: 'Apply',
        applying: 'Applying...',
        applied: 'Applied',
        remove: 'Remove',
        removing: 'Removing...',
        applyError: 'Failed to apply promotion. Please try again.',
        removeError: 'Failed to remove promotion. Please try again.'
    };

    return resources[label];
}
